import { Component, AfterViewInit, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>
      <!--<div>
      <h2>{{ 'HOME.TITLE' | translate }}</h2>
      <label>
        {{ 'HOME.SELECT' | translate }}
        <select #langSelect (change)="cambioIdioma(langSelect.value)">
          <option *ngFor="let lang of translateService.getLangs()"
          [value]="lang" [selected]="lang === translateService.currentLang">{{ lang }}</option>
        </select>
      </label>
    </div>-->
  `
})
export class AppComponent {
  title = 'albapark-front';

  constructor(public translateService: TranslateService) {
    translateService.addLangs(['es', 'en']); // anado lenguaje
    const browserLang = this.translateService.getBrowserLang(); // Coge lenguaje del navegador
    this.translateService.use(browserLang.match(/es|en/) ? browserLang : 'es'); //
  }

  cambioIdioma(_id) {
    this.translateService.use(_id);
  }


}
